export default __webpack_public_path__ + "static/media/spice.0fd2f1e9.svg";